{
  "dec-explorer": {
    "title": "<h2>Discover the model benefits \nusing DEC Explorer</h2>",
    "description": "Quantify in 3 simple steps the results you can achieve by adopting the DEC Energy solution: <ul><li>Choose a plant from the available ones.</li><li>Enter your renewable production target</li><li>Get an immediate quantitative analysis</li></ul>",
    "cta": "Use DEC Explorer",
    "tag": "<Logo/> EXPLORER"
  },

  "redirect": {
    "head": {
      "tag": "THE DEC ENERGY SOLUTION",
      "title": "<h2>Discover the benefits of adopting our model</h2>"
    },
    "left": {
      "title": "<h3>Make your renewable energy procurement profitable</h3>",
      "cta": "For energy managers"
    },
    "right": {
      "title": "<h3>Contribute to the energy transition with real and communicable impact</h3> ",
      "cta": "For sustainability managers"
    }
  },
  "calendly": {
    "tag": "DISCOVER ALL THE BENEFITS",
    "title": "<h2>Discover how to make \nyour GO consumption profitable</h2>",
    "description": "Book a free consultation with our experts to receive a tailored analysis\n on how much you can save with DEC (on your electricity consumption)."
  }
}
